import React from "react";
import VideoSection from "./components/VideoSection3";
import MiddleSection from "./components/MiddleSection";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    slug: "ia-sst",
    title: "IA SST: La Revolución que Está Transformando la Seguridad Laboral en Latinoamérica",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/94ac38e7-8663-495e-882d-7916596cf5f7.png",
  },
  {
    slug: "analisis-predictivo-sst",
    title: "Análisis Predictivo: Cómo la IA anticipa accidentes laborales antes de que ocurran",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/cc3d8745-6624-471a-b08d-d67f3a4b2673.png",
  },
  {
    slug: "chatgpt-sst",
    title: "Cómo Usar ChatGPT para SST: 15 Prompts Que Todo Profesional Debe Conocer",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/385cab1f-e6b8-4def-a016-ad8bfe1040f6.png",
  },
  {
    slug: "automatizacion-sst",
    title: "Automatización de Procesos en Seguridad Laboral: Mi Metodología Probada en +50 Empresas",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/0680a387-cdf7-4627-bac2-f85cb07ee897.png",
  },
  {
    slug: "7-herramientas-ia-para-sst",
    title: "Las 7 Mejores Herramientas de IA que Están Revolucionando la Productividad en SST",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/5d71b4af-c1f6-47cd-a0f5-9ea933124f7a.png",
  },
  {
    slug: "roi-ia-sst",
    title: "ROI de la IA en SST: Cómo Medí un 300% de Aumento en Eficiencia",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/f52d80c9-84e2-434c-98da-8266a14013d0.png",
  },
  {
    slug: "Transformacion-digital-ia-sst",
    title: "Transformación Digital en SST: El Framework que Uso con Mis Clientes",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/8a1a19f5-bdbf-41bf-84b2-c5954151aa7a.png",
  },
  {
    slug: "errores-fatalas-al-implementar-inteligencia-artificial-en-seguridad-y-salud-en-el-trabajo",
    title: "Errores Fatales al Implementar IA en Seguridad Laboral (Y Cómo Evitarlos)",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/e5567fd9-c2d1-45ad-9c52-f7879da49b14.png",
  },
  {
    slug: "el-futuro-de-la-ia-en-la-seguridad-y-salud-en-el-trabajo",
    title: "El Futuro de la IA en SST: Predicciones para 2025-2030",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/e3b0bf75-5228-4e9b-be8c-71d6f96bbeaf.png",
  },
  {
    slug: "mi-viaje-transformando-empresas-con-sst",
    title: "De Tradicional a Digital: Mi Journey Transformando Empresas con IA en SST",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/9b51c3ce-19d7-4e57-9cab-cd2fdc256e60.png",
  },
  {
    slug: "primer-taller-iasst",
    title: "Primer taller de IA para SST en latinoamerica",
    image: "https://celebratufiesta.com.co/wp-content/uploads/2025/08/Imagen-de-WhatsApp-2025-08-27-a-las-14.04.40_8368b956.jpg",
  },



];

const BlogErnesto = () => {
  return (
    <div className="min-h-screen bg-black text-white bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] bg-repeat">
      <VideoSection />
      <MiddleSection />

      <div className="py-12 px-4 md:px-12">
        <h1 className="text-4xl font-extrabold text-center text-[#FFD100] mb-12">
          CÓMO SER MÁS EFICIENTE EN SEGURIDAD Y SALUD EN EL TRABAJO CON INTELIGENCIA ARTIFICIAL
        </h1>
        <h1 className="text-4xl font-extrabold text-center text-[#FFD100] mb-12">
          BY ERNESTO MORA
        </h1>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {blogPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/post/${post.slug}`}
              className="cursor-pointer rounded-xl overflow-hidden shadow-lg border border-[#FFD100] transition hover:scale-105 max-w-xs mx-auto bg-black"
            >
              {/* Imagen */}
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-[280px] object-contain bg-black"
              />

              {/* Título fuera de la imagen */}
              <div className="p-4 text-center">
                <h2 className="text-[#FFD100] text-base font-semibold">
                  {post.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogErnesto;
